// When we check the status of the terminal with a call to /connect/v1/device/status or as response to another
// request these are the possible states. The state needs to be IDLE for a new request to be accepted.
const CloverStatusResponse = Object.freeze({
    IDLE: 'IDLE',
    BUSY: 'BUSY',
    WAITING_FOR_CUSTOMER: 'WAITING_FOR_CUSTOMER',
    UNKNOWN: 'UNKNOWN',
});

module.exports = CloverStatusResponse;
